import { FC, useContext } from "react";

import appStyles from "../../../App.module.css";

import { formatDate } from "../../../app-constants";
import { PortuguesePurchasePathContext } from "../../PortuguesePurchasePath";
import { IPortuguesePurchasePathContext } from "../../config/interface";
import { calculateAge } from "../../config/portuguese-Constant";

interface PPTripSummaryProps {}

const PPTripSummary: FC<PPTripSummaryProps> = (props: PPTripSummaryProps) => {
  const { quoteData } = useContext(PortuguesePurchasePathContext) as IPortuguesePurchasePathContext;

  return (
    <div className={`${appStyles.tripSummary} ${appStyles.tripSummaryVisible}`}>
      <div className={`${appStyles.tripSummaryTitle} ${appStyles.tripSummaryAlwaysOpen}`}>
        <h4>Trip Summary</h4>
      </div>
      <div className={`${appStyles.tripSummaryContent}`}>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Destination(s)</div>
          <div className={appStyles.tripSummaryValue}>{quoteData?.regions[0].label}</div>
        </div>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Cover Period</div>
          <div className={appStyles.tripSummaryValue}>
            {`${formatDate(quoteData.start_date)} to
            ${formatDate(quoteData.end_date)}`}
          </div>
        </div>

        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>No. of Insured(s)</div>
          <div className={appStyles.tripSummaryValue}>1</div>
        </div>
        <div className={`${appStyles.tripSummaryRow}`}>
          <div className={appStyles.tripSummaryLabel}>Age at the time of purchase</div>
          <div className={appStyles.tripSummaryValue}>{calculateAge(quoteData.main_applicant).years}</div>
        </div>
      </div>
    </div>
  );
};

export default PPTripSummary;
